;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	Backbone.Form.editors.ImagePicker = Backbone.Form.editors.Base.extend({
		className: 'imageUploader',
		events: {
			'change input[type=file]':  'uploadFile',
			'click .remove':            'removeFile',
			'click .upload-img-button': 'fireUploadInput',
			'click #uploaded-image':    'fireUploadInput'
		},

		initialize: function(options) {
			Backbone.Form.editors.Base.prototype.initialize.call(this, options);
			const accepted_image_formats = this.buildFileUploadImageAcceptAttributeString(options.schema.image_formats);
			var avatar_url = '';

			if(options.model.get('id')){
				avatar_url =  options.model.get('avatar_url');
			}
			else {
				avatar_url = options.schema.user_img_url;
			}
			this.img_url = options.schema.user_img_url;
			this.button_text  = options.schema.button_text ? options.schema.button_text : _.mixinTranslate('my_account_upload','Upload');
			this.$input = $('<input type="hidden" name="'+this.key+'" />');
			this.$uploadInput = $('<input type="file" style="display: none" accept="' + accepted_image_formats + '" />');
			this.$image = $('<img id="uploaded-image" src="'+avatar_url+'" alt="your avatar">');
			this.$button = $('<p class="upload-img-button">'+this.button_text+'</p>');
		},
		getValue: function(value) {
			var val = this.value;
			return val ? val : '';
		},
		setValue: function(value) {
			this.value = value;
			this.model.set('avatar', value);
		},
		render: function(options) {
			Backbone.Form.editors.Base.prototype.render.apply(this, arguments);
			//this.$el.parent().eq(1).css('display', 'none')

			this.$el.append(this.$image);
			this.$el.append(this.$button);
			this.$el.append(this.$input);
			this.$el.append(this.$uploadInput);

			return this;
		},
		uploadFile: function(e) {
			var file = this.$uploadInput.get(0).files[0];
			if(this.checkFormatImage(file)){
			//TODO::Yuri fix image rotation uploaded from iphone
			this.setValue(file);
			this.readURL(this.$uploadInput.get(0));
			this.trigger('change', this);
			}
			return this;
		},
		removeFile: function(ev) {
			if (ev) ev.preventDefault();
			var url = $(ev.currentTarget).data('url');
			var files = this.getValue();
			this.setValue(_(files).reject(function(one) {
				return one.url === url;
			}));
		},
		readURL: function(input) {
			var _this = this;
			if (input.files && input.files[0]) {
				var reader = new FileReader();
				reader.onload = function (e) {
					_this.$image.attr('src', e.target.result);
				};
				reader.readAsDataURL(input.files[0]);
			}
		},
		fireUploadInput: function(){
			this.$uploadInput.click();
		},
		/**
		 * buildImageAcceptString Builds string for accept attribute on file upload input, specifically for images
		 * @param  {Array} formats Must be MIME image type or file extension eg. ['.jpg', 'image/png']
		 * @return {String} eg. '.jpg,image/png'
		 */
		buildFileUploadImageAcceptAttributeString: function (formats) {
			if (!formats) {
				formats = ['image/*'];
			}
			if(Array.isArray(formats) === false) {
				throw 'formats must be an array';
			}

			return formats.join(',');
		},

		checkFormatImage(file){
			var type_file = file.type;

			return type_file.match(/image\/.*/g);
		}
	});


}(window, APP, Backbone, Marionette, $, _));